import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <>
      <section id="hero_section" className="hero-section-all">
        <div className="container">
          <h1>Radiate Brand Brilliance</h1>
          <p>High-impact marketing solutions for ambitious brands</p>
          <div className="hero-wrapper">
            <div className="hero-wrapper-text">
              <div class="glow-btn">
                <div class="btn-glow white"></div>
                <Link to="/about#contact_us" class="btn-animated white">
                  Let’s Light It Up
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
